"use client";
import * as React from "react";
const SvgSendRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.15 13.93 15.5 7.76a.83.83 0 0 0 0-1.52L1.15.07A.82.82 0 0 0 .01.82L0 4.62a.8.8 0 0 0 .72.82L12.34 7 .72 8.55a.83.83 0 0 0-.72.83v3.8c0 .58.6.99 1.15.75" }));
export {
  SvgSendRound as default
};
